// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2dEem","colMaxWidth":"Table_colMaxWidth__1kgzG"};